<p>select-bom-popup works!</p>
